export default __webpack_public_path__ + "static/media/nwokeOma.337afa83.jpg";